import React, { useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../../helpers';

function Create({ meClose, loadList }) {



	const [formData, setFormData] = useState({
		name: '',
		country_code: '',
		sender_id: '',
		require_sender_id: '',
		code_name: '',
	});

	const FormSchema = Yup.object().shape({
		name: Yup.string().required('Required'),
		country_code: Yup.string().matches(/^\d+$/, 'Must be a Country Code').required('Required'),
		require_sender_id: Yup.string().required('Required'),
	});


	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values
		const url = `${process.env.REACT_APP_API_URL}/country/create`;
		await fetchWrapper.post(url, data)
		loadList()
		meClose();
		toast(`Record has been saved `, {
			type: "info"
		});
	}

	const senderList = {
		data: [
			{ id: 1, name: "Yes" },
			{ id: 0, name: "No" }
		]
	};

	return (


		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>

			<Box mb="10px">
				<InputText name="name" title="Country Name" placeholder="Country Name" inputProps={{ isRequired: true }} />
			</Box>
			<Box mb="10px">
				<InputText name="country_code" title="Country Code" placeholder="Country Code Like(92)" inputProps={{ isRequired: true }}/>
			</Box>

			<Box mb="10px">
				<InputText name="code_name" title="Country Code Name " placeholder="Country Code Name (Like PK)" inputProps={{ isRequired: true }}/>
			</Box>
			<Box mb="10px">
				<InputText name="sender_id" title="Sender ID" placeholder="Sender ID" inputProps={{ isRequired: true }}/>
			</Box>

			<Box mb="10px">
				<SelectField name="require_sender_id" title="Registered Sender ID" list={senderList}  isRequired/>
			</Box>





			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}

				type='submit'
			>
				Add New Country
			</Button>
		</Form>


	)
}

export default Create;